<div class="px-2">
  <button type="button"
    class="btn btn-link text-primary ps-0 d-inline-flex align-items-center gap-1 mb-2 text-decoration-none"
    (click)="goBack()">
    <i-bs name="chevron-left" width="16" height="16"></i-bs>
    Back
  </button>

  @if (loading && !user) {
  <div class="text-center py-5 text-muted">
    <span class="spinner-border spinner-border-sm me-2" role="status"></span>
    Loading…
  </div>
  }

  @if (errorMessage && !user) {
  <div class="card border bg-light rounded-3 shadow-none">
    <div class="card-body text-center py-4 text-muted">
      <i-bs name="exclamation-triangle-fill" width="2rem" height="2rem" class="d-block mx-auto mb-2 text-danger"></i-bs>
      {{ errorMessage }}
    </div>
  </div>
  }

  @if (user) {
  <div class="bg-white rounded-3 p-2">
    <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
      <div class="d-flex align-items-start gap-2">
        <span class="position-relative d-inline-flex flex-shrink-0">
          <span
            class="rounded-circle bg-primary-dark text-white fw-bold d-flex align-items-center justify-content-center"
            style="width: 44px; height: 44px; font-size: 16px">
            {{ userInitials }}
          </span>
          <span *ngIf="deviceId" class="rounded-circle position-absolute border border-white"
            [ngClass]="watchSocketStatus === 'Connected' ? 'bg-success-light' : 'bg-gray-light'"
            style="width: 12px; height: 12px; bottom: 0; right: 0"
            [attr.title]="watchSocketStatus === 'Connected' ? 'Device Online' : 'Device Offline'"
            [attr.aria-label]="watchSocketStatus === 'Connected' ? 'Device Online' : 'Device Offline'"></span>
        </span>
        <div class="d-flex flex-column mt-1">
          <div class="d-flex align-items-center gap-1">
            <span class="fw-semibold h6 mb-0 text-gray-dark">{{ user?.demographic?.firstName }} {{
              user?.demographic?.lastName }}</span>
            <span class="fw-bold badge rounded-pill bg-opacity-25" [ngClass]="{
                  'bg-primary text-primary': user?.status?.toLowerCase() === userStatus.NEW,
                  'bg-success-light text-success': user?.status?.toLowerCase() === userStatus.ACTIVATED,
                  'bg-warning text-warning': user?.status?.toLowerCase() === userStatus.IN_PROGRESS
                }">{{ user?.status }}</span>
          </div>
          <div class="d-flex flex-column small text-muted">
            <span>{{ user?.demographic?.email }}</span>
            <span>{{ user?.demographic?.phone | formatPhoneNumber }}</span>
          </div>
          <a class="small text-primary" style="cursor: pointer;margin-left:6px;"
            (click)="endUserProfileInformationComponent.onOpenSidenav()">
            Profile Details
          </a>
        </div>
      </div>

      <div class="d-flex align-items-center gap-1">
        @if (user?.emergencyCadence && !isLoggedInEndUser) {
        <button type="button" class="btn btn-outline-primary btn-outline-border-width-1" (click)="onRemoveCadence()"
          [disabled]="isLoading.removeEmergencyCadence">
          @if (isLoading.removeEmergencyCadence) {
          <span class="spinner-grow spinner-grow-sm ms-1" role="status" aria-hidden="true"></span>
          }
          Remove Cadence
        </button>
        }
        @if (displaySimulationButton && selectedPair) {
        @if (!isSimulationRunning) {
        <button type="button" class="btn btn-outline-primary btn-outline-border-width-1"
          (click)="openSimulationModal()">Run Simulation</button>
        } @else if (isSimulationCompleted) {
        <button type="button" class="btn btn-outline-success btn-outline-border-width-1"
          (click)="restartUserSimulation()">Restart Simulation</button>
        } @else {
        <button type="button" class="btn btn-outline-danger btn-outline-border-width-1"
          (click)="stopUserSimulation()">Stop Simulation</button>
        }
        }
        <button type="button" class="btn btn-outline-primary btn-outline-border-width-1"
          (click)="setViewMode(viewMode === 'table' ? 'map' : 'table')"
          [attr.aria-label]="viewMode === 'table' ? 'Switch to map view' : 'Switch to table view'"
          [mdbTooltip]="viewMode === 'table' ? 'Map view' : 'Table view'">
          <i-bs [name]="viewMode === 'table' ? 'map-fill' : 'list'" width="16" height="16"></i-bs>
        </button>
        <button type="button" class="btn btn-outline-primary btn-outline-border-width-1" (click)="onRequestRecording()"
          aria-label="Request Audio Recording">
          <i-bs name="headphones" width="16" height="16"></i-bs>
        </button>
        @if (selectedPair) {
        <button type="button" class="btn btn-outline-primary btn-outline-border-width-1"
          (click)="perpetratorSidebarComponent.onOpen()" aria-label="Perpetrator quick view">
          <i-bs name="people-fill" width="16" height="16"></i-bs>
        </button>
        }
        @if (isSuperAdmin) {
        <button type="button" class="btn btn-outline-primary btn-outline-border-width-1"
          (click)="settingsSidebarComponent.onOpen()" aria-label="Settings">
          <i-bs name="gear-fill" width="16" height="16"></i-bs>
        </button>
        }
        @if (!isLoggedInEndUser) {
        <button type="button" class="btn btn-outline-primary btn-outline-border-width-1"
          (click)="notesComponent.onOpenNotes()">
          Notes
        </button>
        }
      </div>
    </div>

    @if (viewMode === 'table') {
    <div class="d-flex justify-content-end mb-3">
      <form [formGroup]="userDetailForm" autocomplete="off">
        <div class="d-flex align-items-end">
          <div class="me-2">
            <label for="v2CreatedFrom" class="form-label">Created From</label>
            <mdb-form-control>
              <div class="datepicker-wrapper">
                <input [readonly]="true" mdbInput [mdbDatepicker]="v2CreatedFrom" type="text" class="form-control"
                  id="v2CreatedFrom" formControlName="createdFrom" />
                @if (userDetailForm.value.createdFrom) {
                <button class="datepicker-clear-button" (click)="clearDatePicked('createdFrom')">
                  <i class="fas fa-times"></i>
                </button>
                }
                <mdb-datepicker-toggle [mdbDatepicker]="v2CreatedFrom"></mdb-datepicker-toggle>
                <mdb-datepicker [inline]="true" [format]="mdbDateFormat" [maxDate]="getMaxDate()" #v2CreatedFrom
                  (dateChanged)="getFiltered(true, true)"></mdb-datepicker>
              </div>
            </mdb-form-control>
          </div>
          <div class="me-2">
            <label for="v2CreatedTo" class="form-label">Created To</label>
            <mdb-form-control>
              <div class="datepicker-wrapper">
                <input mdbInput [readonly]="true" [mdbDatepicker]="v2CreatedTo" type="text" class="form-control"
                  id="v2CreatedTo" formControlName="createdTo" />
                @if (userDetailForm.value.createdTo) {
                <button class="datepicker-clear-button" (click)="clearDatePicked('createdTo')">
                  <i class="fas fa-times"></i>
                </button>
                }
                <mdb-datepicker-toggle [mdbDatepicker]="v2CreatedTo"></mdb-datepicker-toggle>
                <mdb-datepicker [inline]="true" [format]="mdbDateFormat"
                  [minDate]="userDetailForm.controls['createdFrom'].value && getMinDate()" [maxDate]="getMaxDate()"
                  #v2CreatedTo (dateChanged)="getFiltered(true, true)"></mdb-datepicker>
              </div>
            </mdb-form-control>
          </div>
          <div>
            <button type="button" class="btn btn-outline-primary btn-outline-border-width-1"
              (click)="openConfigureColumnModal(userColumnData)">
              <i-bs name="list" width="16" height="16"></i-bs>
              Customize Columns
            </button>
          </div>
        </div>
      </form>
    </div>

    <app-table [tableConfig]="tableConfig" [convertToLocal]="user?.watchAppVersion == 2" [module]="'Check in module'"
      [loading]="loading" [getRowClass]="getActivityRowClass" (onScrollToBottom)="scrollToBottom($event)"
      [notFoundMessage]="notFoundMessage" (sendEvent)="receiveEvent($event)">
    </app-table>
    } @else if (viewMode === 'map') {
    <div class="live-map-row d-flex gap-3 flex-wrap flex-lg-nowrap align-items-start">
      <div class="live-map-column flex-grow-1" style="min-width: 0">
        <div #liveMapCard class="live-map-card position-relative rounded-3 overflow-hidden"
          [class.live-map-card-fullscreen]="isFullscreen">
          @if (mapParties.length > 0) {
          <app-google-map [height]="isFullscreen ? '100%' : '580px'" [parties]="mapParties" [zones]="zoneConfig"
            [mapStyles]="isDarkMode ? darkMapStyles : lightMapStyles" [cleanChrome]="true"
            [markersDraggable]="canDragMarkers" (partyDragEnd)="onPartyDragEnd($event)"></app-google-map>

          @if (isSimulationRunning) {
          <app-proximity-simulation-overlay [distanceParameter]="selectedPair?.distanceParameter || 'yard'"
            [isPerpetrator]="isPerpetrator" [threatPairId]="selectedPair?.id ?? ''"
            [title]="'Simulation mode · ' + (selectedPair?.survivor?.name || 'Threat pair replay') + ' / ' + (selectedPair?.perpetrator?.name || 'Perpetrator') + ' - ' + simulationScenarioTitle"
            [zone]="zoneState" [completedCheckIns]="simulationProgress.completedCheckIns"
            [totalCheckIns]="simulationProgress.totalCheckIns"
            [survivorName]="selectedPair?.survivor?.name || 'Survivor'"
            [perpetratorName]="selectedPair?.perpetrator?.name || 'Perpetrator'" [socketUserIds]="simulationUserIds"
            [telemetryExpanded]="showLatestCheckIn" [isDraggableMode]="isDraggableSimulationRunning"
            [selectedActivity]="simulationActivity"
            [survivorCheckInTimeSeconds]="simulationCheckInTimes.survivorSeconds"
            [perpetratorCheckInTimeSeconds]="simulationCheckInTimes.perpetratorSeconds"
            [isLocalMode]="isLocalSimulationRunning" [localAlert]="localSimulationAlert"
            [localAdvocateLog]="localSimulationLog" (activityChange)="onSimulationActivityChange($event)"
            (editSimulation)="editSimulation()" (close)="stopUserSimulation()" (restart)="restartUserSimulation()">
          </app-proximity-simulation-overlay>
          }

          <!--<div class="live-map-caption d-flex flex-column">
            <span class="d-inline-flex align-items-center gap-1">
              <i-bs name="shield-lock-fill" width="14" height="14"></i-bs>
              AEGIS PROXIMITY
            </span>
            <span class="live-map-caption-sub">Threat proximity monitor</span>
          </div>-->
          @if (isInAlertZone && !isPerpetrator) {
          <div class="live-map-banner-wrap">
            <div class="live-map-banner d-inline-flex align-items-center gap-2"
              [ngClass]="zoneState === 'red' ? 'live-map-banner-red' : 'live-map-banner-yellow'">
              <span class="live-map-banner-icon d-inline-flex align-items-center justify-content-center flex-shrink-0">
                <i-bs name="exclamation-triangle-fill" width="13" height="13"></i-bs>
              </span>
              <div class="d-flex flex-column">
                <span class="small fw-semibold">{{ mapBannerTitle }}</span>
                <span class="small live-map-banner-detail">{{ mapBannerDetail }}</span>
              </div>
            </div>
          </div>
          }
          } @else {
          <app-google-map [height]="isFullscreen ? '100%' : '580px'" [features]="mapFeatures"
            [customMarkers]="emergencyTriggeredLocations" [mapStyles]="isDarkMode ? darkMapStyles : lightMapStyles"
            [cleanChrome]="true"></app-google-map>
          }

          @if (distanceDisplayLabel || latestCheckIn) {
          <div class="live-map-telemetry">
            <div class="telemetry-header">
              <div class="telemetry-label">Live Telemetry</div>
              @if (statusPillLabel.toLowerCase() !== 'unknown') {
              <span class="live-map-status-pill badge rounded-pill" [ngClass]="statusPillClass">{{ statusPillLabel
                }}</span>
              }
            </div>
            @if (distanceDisplayLabel && !isPerpetrator) {
            <div class="telemetry-sublabel">Current distance</div>
            <div class="telemetry-distance"
              [ngClass]="zoneState === 'red' ? 'text-danger' : zoneState === 'yellow' ? 'text-warning' : 'text-success'">
              {{ distanceDisplayLabel }}</div>

            <!--<div class="telemetry-row"><span>Yellow radius</span><span>{{ zoneRadiiLabel.yellow }}</span></div>
              <div class="telemetry-row"><span>Red radius</span><span>{{ zoneRadiiLabel.red }}</span></div>
              <div class="telemetry-row">
                <span>Status</span>
                <span
                  [ngClass]="zoneState === 'red' ? 'text-danger' : zoneState === 'yellow' ? 'text-warning' : 'text-success'">{{
                  statusPillLabel }}</span>
              </div>
              <div class="telemetry-row"><span>Perp. heading</span><span>{{ perpetratorSummary?.headingLabel ?? '—'
                  }}</span></div>
              <div class="telemetry-row"><span>Movement</span><span [ngClass]="proximityTrendClass">{{
                  proximityTrendLabel() }}</span></div>
              <div class="telemetry-row"><span>Closing rate</span><span [ngClass]="proximityTrendClass">{{
                  closingRateLabel }}</span></div>
              <div class="telemetry-row"><span>Last update</span><span>{{ perpetratorSummary?.lastUpdatedLabel ?? '—'
                  }}</span></div>
              <div class="telemetry-row"><span>Accuracy</span><span>{{ accuracyLabel }}</span></div>-->
            }

            <button type="button" class="telemetry-sublabel telemetry-check-in-toggle"
              [class.mt-2]="!!distanceDisplayLabel" (click)="toggleLatestCheckIn()"
              [attr.aria-expanded]="showLatestCheckIn">
              <span>Latest check-in</span>
              <i-bs name="chevron-down" width="12" height="12"
                [class.telemetry-check-in-chevron-open]="showLatestCheckIn"></i-bs>
            </button>
            @if (showLatestCheckIn) {
            <div class="telemetry-row"><span>GPS</span><span>{{ latestCheckInGpsLabel }}</span></div>
            <div class="telemetry-row"><span>Heart rate</span><span>{{ latestCheckInHeartRateLabel }}</span></div>
            <div class="telemetry-row"><span>Signal</span><span [innerHTML]="latestCheckInSignalHtml"></span></div>
            <div class="telemetry-row"><span>Wrist</span><span>{{ latestCheckInWristLabel }}</span></div>
            <div class="telemetry-row"><span>Battery</span><span>{{ latestCheckInBatteryLabel }}</span></div>
            <div class="telemetry-row"><span>Charging</span><span>{{ latestCheckInChargingLabel }}</span></div>
            <div class="telemetry-row"><span>Timestamp</span><span>{{ latestCheckInTimestampLabel }}</span></div>
            }
          </div>
          }

          <button type="button" class="live-map-theme-btn" (click)="toggleDarkMode()"
            [attr.aria-label]="isDarkMode ? 'Switch to light map' : 'Switch to dark map'">
            <i-bs [name]="isDarkMode ? 'sun-fill' : 'moon-fill'" width="16" height="16"></i-bs>
          </button>

          <button type="button" class="live-map-expand-btn" (click)="toggleFullscreen()"
            [attr.aria-label]="isFullscreen ? 'Exit full screen' : 'Enter full screen'">
            <i-bs [name]="isFullscreen ? 'arrows-angle-contract' : 'arrows-angle-expand'" width="16" height="16"></i-bs>
          </button>
        </div>

        @if (isZoneCentreStale) {
        <div class="small text-warning-emphasis d-flex align-items-center gap-1 mt-2">
          <i-bs name="exclamation-triangle-fill"></i-bs>
          Protected Party's position may be outdated — the zone shown may be unreliable.
        </div>
        }

        <div class="live-map-activity small">
          @if (eventLog.length) {
          @for (line of eventLog; track $index) {
          <div>{{ line.message }}</div>
          }
          } @else {
          <span class="text-muted">No zone events yet this session.</span>
          }
        </div>
      </div>

      <!--@if (!isFullscreen) {
      <div class="live-map-side-card card border-0 rounded-3 shadow-sm flex-shrink-0">
        <div class="card-body d-flex flex-column gap-2 p-2">
          <span class="fw-medium text-gray-dark">{{ counterpartRole }}</span>
          <hr class="my-0" />
          <div class="d-flex align-items-start gap-2">
            <span
              class="rounded-circle bg-primary-dark text-white fw-bold d-flex align-items-center justify-content-center flex-shrink-0"
              style="width: 32px; height: 32px; font-size: 12px">{{ counterpartUser?.initials }}</span>
            <div class="d-flex flex-column flex-grow-1">
              <span class="fw-medium text-gray-dark">{{ counterpartUser?.name }}</span>
              @if (counterpartUser?.organization?.name) {
              <span class="badge rounded-pill bg-opacity-10 bg-info text-info align-self-start">{{
                counterpartUser?.organization?.name }}</span>
              }
              <div class="d-flex gap-2 small text-muted mt-1 align-items-center">
                <span class="d-inline-flex align-items-center gap-1">
                  <i class="fas fa-map-marker-alt"></i>
                  {{ selectedPair.distanceThreshold || 0 }} m
                </span>
                <span class="d-inline-flex align-items-center gap-1">
                  <span class="rounded-circle flex-shrink-0 d-inline-block"
                    [ngClass]="selectedPair.status.toLowerCase() === 'active' ? 'bg-success' : 'bg-secondary'"
                    style="width: 6px; height: 6px"></span>
                  {{ selectedPair.status | titlecase }}
                </span>
              </div>
            </div>
          </div>
          @if (isInAlertZone) {
          <button type="button"
            class="live-map-alert-btn btn btn-sm rounded-1 d-inline-flex align-items-center gap-1 align-self-start"
            (click)="onThreatPairAlerts(selectedPair)">
            <i-bs name="exclamation-triangle-fill" width="14" height="14"></i-bs>
            Alert
          </button>
          }
        </div>
      </div>
    }-->
    </div>
    }
  </div>
  }
</div>

<app-end-user-profile-information [data]="user"></app-end-user-profile-information>

<app-notes [isFetchingNotes]="isLoadingNotes" [data]="notes" [notedUserId]="userId"></app-notes>

<app-perpetrator-sidebar [counterpartRole]="counterpartRole" [counterpartUser]="counterpartUser"
  [selectedPair]="selectedPair" (alertClick)="onThreatPairAlerts($event, selectedPair?.distanceParameter ?? 'meter')">
</app-perpetrator-sidebar>

<app-settings-sidebar [isLoggedInEndUser]="isLoggedInEndUser" [deviceId]="deviceId" [device]="device"
  [isLoading]="isLoading" [canBeginTest]="canBeginTest" [testEndTime]="testEndTime"
  [remainingTimeInMilliseconds]="remainingTimeInMilliseconds" (gpsCheck)="onGpsCheck()"
  (networkCheck)="onNetworkCheck()" (downloadLogs)="onDownloadLogs()" (downloadRrmsLogs)="onDownloadRRMSLogs()"
  (beginTest)="beginTest()" (stopTest)="onStopTest()" (editConfiguration)="openEditConfigurationModal()">
</app-settings-sidebar>

<app-threat-pair-alert-log #threatPairAlertLog></app-threat-pair-alert-log>